import { toCurrencyString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/currency.formatters';
import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoInvoiceListTotalTtcCellProps
  extends CellContext<
    EmspUserInvoiceBaseModel,
    EmspUserInvoiceBaseModel['totalTTC']
  > {}

export const EmspBoInvoiceListTotalTtcCell = (
  props: EmspBoInvoiceListTotalTtcCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <span>{toCurrencyString(getValue(), row.original.currency)}</span>;
};
